import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class PartnerService {
  constructor(private http: HttpClient) {}

  public validateBedMember(
    firstname: string,
    lastname: string,
    bedNumber: string
  ): Observable<boolean> {
    const formData = new FormData();
    formData.append('mode', 'validateBedMember');
    formData.append('firstname', firstname);
    formData.append('lastname', lastname);
    formData.append('bedNumber', bedNumber);

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: boolean;
      }>(environment.authority_short + 'partner.php', formData)
      .pipe(
        map(response => response.data),
        catchError(() => {
          return throwError(() => new Error('member validation failed'));
        })
      );
  }

  public validateLogoPassword(logoPassword: string): Observable<boolean> {
    const formData = new FormData();
    formData.append('mode', 'validateLogoPassword');
    formData.append('logoPassword', logoPassword);

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: boolean;
      }>(environment.authority_short + 'partner.php', formData)
      .pipe(
        map(response => response.data),
        catchError(() => {
          return throwError(() => new Error('member validation failed'));
        })
      );
  }

  public validatePassword(
    condition: string,
    password: string
  ): Observable<{
    success: boolean;
    message: string;
    data: boolean;
  }> {
    const formData = new FormData();
    formData.append('mode', 'validatePassword');
    formData.append('condition', condition);
    formData.append('password', password);

    return this.http
      .post<{
        success: boolean;
        message: string;
        data: boolean;
      }>(environment.authority_short + 'partner.php', formData)
      .pipe(
        map(response => response),
        catchError(() => {
          return throwError(() => new Error('password validation failed'));
        })
      );
  }
}
